import * as S from "./styles";

const FAQs = () => {
  return (
    <S.FAQWrapper>
      <S.Container>
        <S.Contain>
          <h1>FAQs</h1>
          <div className="text-white">Last Updated: August 8, 2026</div>
          <div className="text-white my-2 font-semibold">
            Welcome to Fanxo: Where Creators make money from Their Biggest Fans
          </div>
          <div className="text-white my-2 font-semibold">
            Frequently Asked Questions (FAQ)
          </div>
          <div className="my-5 border border-cyan-50 border-spacing-2" />
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              1. What is Fanxo? How does it work?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Fanxo helps creators monetize by turning their free fan following
              into premium fans. Creators set up an account, add their Fanxo link
              to their social media link-in-bio, and can offer premium access,
              exclusive content and paid interactions to fans.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              2. I am a creator. How do I set up my account?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Creators fill out the creator application form and provide their
              social media links. Our team reviews the application before the
              account is approved. For assistance, contact business@fanxo.club.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              3. Is there a limit to what I can earn?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Fanxo does not set a fixed earnings ceiling. Actual earnings depend
              on your audience, pricing, activity, payment success and other
              factors.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              4. What kind of content can I share on Fanxo?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              You can share supported content formats that comply with Fanxo's
              content rules and applicable law, including text, photos, videos,
              updates and behind-the-scenes content.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              5. Is Fanxo free to use for creators?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              There are no upfront creator fees. Fanxo earns a platform share
              from eligible monetization transactions.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              6. How do fans join my premium community?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Fans can open your Fanxo link from Instagram, YouTube or another
              channel, create or access their account, and follow the available
              membership or interaction flow.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              7. Can I control how much to charge for premium content?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Creators can choose pricing from the options and limits supported
              by Fanxo for the relevant monetization feature. Changes apply
              according to the terms shown in the product flow.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              8. How will I receive my earnings?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Fanxo processes eligible payments through its payment
              infrastructure. Creator earnings are paid according to Fanxo's
              payout process, verification requirements and applicable rules.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              9. What makes Fanxo different from other platforms?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Fanxo is built around creator monetization and premium fan
              relationships, including subscriptions, exclusive content, paid
              interactions and one-time fan support, with a focus on a
              brand-safe creator experience.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              10. How long does it take for my account to be approved?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Creator applications are reviewed before approval. Review time can
              vary depending on the information submitted and any checks that
              are required. You will be notified when the account status changes.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              11. Can I change my membership pricing later?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Where the product supports it, you can update your pricing for
              future purchases. Existing subscriptions and renewals remain
              subject to the terms shown for those subscriptions.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              12. What happens if I need help with my account or a payment?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Contact business@fanxo.club with the relevant account and
              transaction details. Payment errors, failed transactions,
              unauthorized transactions and other complaints are handled subject
              to applicable law and payment-provider rules.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              13. Can I link my Fanxo profile to multiple social media accounts?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              You can share your Fanxo profile link across multiple social media
              platforms such as Instagram, YouTube and other supported channels.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              14. Are there any rules about what content I can post on Fanxo?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Yes. Content and interactions must comply with Fanxo's applicable
              terms, community rules and the law. Fanxo may restrict or remove
              content that violates those requirements.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              15. What are gifts on Fanxo?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Gifts are optional, one-time payments a fan can send to a creator
              as support. Fanxo's role is to process and deliver the gift
              transaction to the creator. A gift is not a subscription and does
              not by itself promise a reply, custom content, access or any other
              benefit unless the creator separately offers one.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              16. Can a completed gift be refunded?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              Once a gift has been successfully processed and delivered, it is
              final for change-of-mind, dissatisfaction or creator-engagement
              purposes. A creator choosing not to reply, engage or provide an
              expected interaction does not by itself create a refund right.
              This does not limit rights that cannot lawfully be excluded or
              remedies for verified duplicate, failed, unauthorized or
              incorrectly processed transactions. Contact business@fanxo.club
              promptly with the transaction details if there is a payment
              problem.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              17. Does paying to send a direct message guarantee a creator reply?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              No. A paid message pays for Fanxo to process and deliver the
              message to the intended creator. Whether, when or how the creator
              replies is entirely at the creator's discretion. Once the paid
              message has been successfully delivered, no refund is due solely
              because the creator does not reply, replies later, or the level of
              engagement does not meet the fan's expectations. Mandatory legal
              and payment-system remedies remain unaffected.
            </div>
          </div>
          <div className="mt-2">
            <div className="text-white my-2 font-semibold">
              18. When is a paid digital service treated as delivered on Fanxo?
            </div>
            <div className="text-white mt-2 font-thin pl-4">
              For premium content or subscription access, delivery occurs when
              the purchased access is successfully unlocked or made available.
              For a paid message, delivery occurs when the message is delivered
              to the intended creator. For a gift, delivery occurs when the gift
              transaction is successfully processed and delivered. After
              delivery, change of mind, dissatisfaction, unused access or a
              creator choosing not to reply or engage do not by themselves
              create a refund right, subject to rights that cannot lawfully be
              excluded and applicable payment-system rules.
            </div>
          </div>
        </S.Contain>
      </S.Container>
    </S.FAQWrapper>
  );
};

export default FAQs;
